import React, { useEffect } from 'react'
import BrandContainer from '../../components/Brand/BrandContainer'
import Pagination from '../../components/Layout/Pagination'
import UseAllBrands from '../../CustomHooks/Brands/UseAllBrands'
import NavBar from '../../components/Layout/NavBar'
import Footer from '../../components/Layout/Footer'
import UseViewSearchProducts from '../../CustomHooks/Products/UseViewSearchProducts'

const AllBrand = () => {
  const [loading, allBrands, pageCount, onPress, SearchValue, ChangeInputSearch] = UseAllBrands()
  const [NumberOfPages, AllLoading, SearchLoading, items, onPressPage, searchProductsFunc, onChangeSearchInput, searchInputValue] = UseViewSearchProducts()
  return (
    <>
      <NavBar onChangeSearchInput={onChangeSearchInput} searchInputValue={searchInputValue} />
      <BrandContainer allBrands={allBrands} />
      {pageCount > 1 ? (<Pagination pageCount={pageCount} onPress={onPress} className="mt-4"/>) : null}
      <Footer/>
    </>
  )
}

export default AllBrand
